
import Modal from "./Modal";
import useViewDocumentModal from "../../hooks/post/useViewDocumentModal";

const ViewDocument = ({ url, name }) => {

  const uViewDocumentModal = useViewDocumentModal()
  
  const content = (
    <>
      <img className="max-w-full max-h-screen"  src={`${process.env.REACT_APP_CDN_URL}/${url}`} alt={"Document"}/>
    </>
  )

  return (
    <Modal 
      isOpen={uViewDocumentModal.isOpen}
      close={uViewDocumentModal.close}
      label={name}
      content={content}
    />
  )
}

export default ViewDocument


